
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import MobileNav from './MobileNav';
import './Navbar.css';

const Navbar = () => {

    const location = useLocation();

    useEffect(() => {
        let links = document.getElementsByClassName('nav_link');
        for (let link of links){
            link.classList.remove('active');
        }
        
        if(location.pathname === '/'){
            document.querySelector('.nav_home').classList.add('active');
        }
        else if(location.pathname === '/myprofile'){
            document.querySelector('.nav_profile').classList.add('active');
        }
        else if(location.pathname === '/howitworks'){
            document.querySelector('.nav_howitworks').classList.add('active');
        }

    }, [location])

    
    const openMobileNav = () => {
        document.querySelector('.mobile_nav').classList.add('show');
    }

    return (
        <nav className="navbar bg-transparent py-6 px-5">
            <div className="flex justify-between items-center max-w-[1400px] mx-auto">


                <Link to = '/' className="max-w-[60px] md:max-w-[70px] flex items-center">
                    <img src = {require('../../assets/images/logo.png')} alt="logo" className="w-full" />
                </Link>

                <div className="hidden lg:flex uppercase text-sm font-[500] tracking-[1.5px]">
                    <Link className = 'nav_home nav_link mx-4' to="/">Market Place</Link>
                    <Link className = 'nav_profile nav_link mx-4' to="/myprofile">My Profile</Link>
                    <Link className = 'nav_howitworks nav_link mx-4' to="/howitworks">How it Works</Link>
                </div>

                <div className='flex items-center'>
                    
                    <div className="dropdown relative z-10 hidden lg:block">
                        <button className="font-bold inline-flex items-center px-5 z-10">
                            <span className="mr-1">Explore</span>
                            <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
                        </button>
                        <ul className="dropdown_menu hidden right-0 2xl:left-0 absolute w-[230px] z-20 shadow-shadow3 bg-[#1f1d2b]">
                            <li className="">
                                <Link to = '/collections' className="rounded-t text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">All NFTs</Link>
                            </li>
                            <li className="">
                                <Link to = '/category/art' className="rounded-t text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Art</Link>
                            </li>
                            <li className="">
                                <Link to = '/category/collectibles' className="text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Collectibles</Link>
                            </li>
                            <li className="">
                                <Link to = '/category/domainnames' className="text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Domain Names</Link>
                            </li>
                            <li className="">
                                <Link to = '/category/music' className="text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Music</Link>
                            </li>
                            <li className="">
                                <Link to = '/category/photography' className="text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Photography</Link>
                            </li>
                            <li className="">
                                <Link to = '/category/virtualworlds' className="text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Virtual Worlds</Link>
                            </li>
                            <li className="">
                                <Link to = '/category/sports' className="text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Sports</Link>
                            </li>
                            <li className="">
                                <Link to = '/category/tradingcards' className="text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Trading Cards</Link>
                            </li>
                            <li className="">
                                <Link to = '/category/utility' className="rounded-b nav_sublink text-[16px] py-4 px-5 block whitespace-no-wrap">Utility</Link>
                            </li>
                        </ul>
                    </div>

                    <Link to = '/connectwallet'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill='currentColor' className='w-[24px] h-[24px]' viewBox="0 0 512 512">
                            <path d="M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"/>
                        </svg>
                    </Link>

                    <div className="dropdown relative z-10 hidden lg:block">
                        <button className="font-bold flex items-center px-5 z-10">
                            <svg xmlns="http://www.w3.org/2000/svg" fill='currentColor' className='w-[24px] h-[24px]' viewBox="0 0 512 512">
                                <path d="M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"/>
                            </svg>
                        </button>
                        <ul className="dropdown_menu hidden absolute right-0 2xl:left-0 w-[230px] z-20 shadow-shadow3 bg-[#1f1d2b]">
                            <li className="">
                                <Link to = '/myprofile' className="rounded-t text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Profile</Link>
                                <Link to="/activity" className="rounded-t text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Activity</Link>
                                <Link to = '/collections' className="rounded-t text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Favorite</Link>
                                <Link to = '/collections' className="rounded-t text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Watchlist</Link>
                                <Link to = '/collections' className="rounded-t text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">My Collections</Link>
                                <Link to = '/myprofile' className="rounded-t text-[16px] nav_sublink border-b-[1px] border-gray-700 py-4 px-5 block whitespace-no-wrap">Settings</Link>
                            </li>
                        </ul>
                    </div>
                    
                    <button className='lg:hidden ml-4' onClick={openMobileNav}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill='currentColor' className='w-[30px] h-[30px] text-white' viewBox="0 0 448 512">
                            <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"/>
                        </svg>
                    </button>
                </div>

            </div>
            <MobileNav />
        </nav>
    )
}

export default Navbar;